export const ColorPickerHook = {
  element: null,
  popup: null,
  hiddenInput: null,
  swatchInput: null,
  outsideClickRef: null,

  mounted() {
    this.element = this.el;
    this.popup = $(this.element).next();
    this.hiddenInput = $(this.element).find("[type='hidden']");
    this.swatchInput = $(this.hiddenInput).next();

    $(this.element).on("click keydown", (event) => {
      if (["Enter", "Space"].includes(event.originalEvent?.code) || event.type === "click") {
        event.stopPropagation();
        event.preventDefault();
        this.popup.toggleClass("hidden");

        // If outsideClick is already set don't rebind it
        if (!this.outsideClickRef) {
          this.outsideClickRef = this.outsideClick.bind(this);
          window.addEventListener("click", this.outsideClickRef);
        }
      }
      if ("Escape" === event.originalEvent?.code && !this.popup.hasClass("hidden")) {
        event.stopPropagation();
        this.hidePopup();
      }
    });

    this.popup.find("div").on("click keydown", (event) => {
      if (["Enter", "Space"].includes(event.originalEvent?.code) || event.type === "click") {
        event.preventDefault();
        const hex = this.rgb2hex(event.target.style.backgroundColor);
        this.hiddenInput.val(hex);
        this.swatchInput.css("background-color", hex);

        this.hidePopup();
        this.element.focus();
      }
    });
  },

  outsideClick(event) {
    if (event.target === this.element || $(event.target).closest(".popup").length) {
      return;
    }

    this.hidePopup();
  },

  hidePopup() {
    window.removeEventListener("click", this.outsideClickRef);
    this.outsideClickRef = null;
    this.popup.addClass("hidden");
  },

  rgb2hex: (rgb) =>
    `#${rgb
      .match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
      .slice(1)
      .map((n) => Number.parseInt(n, 10).toString(16).padStart(2, "0"))
      .join("")}`,
};
